import { ADVERSE_MEDIA_TIME_HORIZON_OPTIONS } from "@/src/services/search_configurations_service";
import { FilterCard, FilterLabel } from "./primitives";

export function TimeHorizonPresetsCard({
  value,
  onChange,
  className = "flex w-full flex-col gap-1",
  disabled = false,
  labelSize = "tiny",
}: {
  value: number | null;
  onChange: (next: number) => void;
  className?: string;
  disabled?: boolean;
  labelSize?: "tiny" | "small";
}) {
  return (
    <FilterCard className={className} disabled={disabled}>
      <FilterLabel size={labelSize}>How far back should we search for adverse media?</FilterLabel>
      <div
        className="flex flex-wrap gap-2"
        role="radiogroup"
        aria-label="How far back should we search for adverse media?"
      >
        {ADVERSE_MEDIA_TIME_HORIZON_OPTIONS.map((opt) => (
          <button
            key={opt.value}
            type="button"
            role="radio"
            aria-checked={value === opt.value}
            onClick={() => onChange(opt.value)}
            disabled={disabled}
            className={[
              "rounded-[4px] border px-3 py-1.5 text-small font-medium transition-colors",
              disabled ? "cursor-not-allowed" : "cursor-pointer",
              value === opt.value
                ? disabled
                  ? "border-green-500-12 bg-green-500-12 text-grey-500"
                  : "border-green-500-12 bg-green-500-12 text-green-700"
                : disabled
                  ? "border-grey-200 bg-grey-50 text-grey-500"
                  : "border-grey-200 bg-white text-grey-900 hover:bg-grey-50",
            ].join(" ")}
          >
            {opt.label}
          </button>
        ))}
      </div>
      <p className={`text-small ${disabled ? "text-grey-500" : "text-grey-600"}`}>
        Search results include articles published from the selected date through today. For
        monitored entries, this also sets the starting point for ongoing monitoring, with new
        articles added automatically as they are published.
      </p>
    </FilterCard>
  );
}
